module.exports = __webpack_public_path__ + "img/1.c11f4d19.jpg";